import(/* webpackMode: "eager", webpackExports: ["NotFoundBody"] */ "/build/apps/maki-frontend/components/shared/notFoundCopy.tsx");
